import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnDestroy,
    OnInit,
} from "@angular/core"
import { ActivatedRoute } from "@angular/router"
import { Subscription } from "rxjs"
import { CH_FACET_ID } from "../../models/constants"
import { Facet } from "../../models/facet.model"
import { BaseNode, CHNode } from "../../models/node.model"
import { SearchInfoModel } from "../../models/searchInfo.model"
import { BrowsingService } from "../../services/browsing.service"
import { FacetingService } from "../../services/faceting.service"
import { SearchingService } from "../../services/searching.service"

@Component({
    selector: "app-facets",
    templateUrl: "./facets.component.html",
    styleUrls: ["./facets.component.less"],
    changeDetection: ChangeDetectionStrategy.Default,
})
export class FacetsComponent implements OnInit, OnDestroy {
    @Input() public syncFacets: boolean = false
    @Input() public premiumCollectionSearch: boolean = false
    public grades: string[]
    public mediaTypes: string[]
    public chFacetInfo = {}
    public nestedFacetsInfo = []
    public subscriptions: Subscription[] = []

    constructor(
        private browsingService: BrowsingService,
        private facetingService: FacetingService,
        private searchingService: SearchingService,
        private route: ActivatedRoute
    ) {}

    public ngOnInit() {
        this.grades = this.facetingService.grades
        this.mediaTypes = this.facetingService.media_type
        this.subscribeToNodeUpdates()
        this.subscribeToFacetsInfo()
    }

    private subscribeToNodeUpdates() {
        this.facetingService.nestedFacetsChanged.next({})
        if (this.premiumCollectionSearch) {
            this.subscriptions.push(
                // CH facet setup
                this.searchingService.searchInfo.subscribe(
                    (searchInfo: SearchInfoModel) => {
                        if (searchInfo.chSectionName) {
                            this.facetingService.setupNestedFacet(
                                CH_FACET_ID,
                                searchInfo.chSectionName,
                                searchInfo.chFilter
                            )
                        }
                        searchInfo.customFilterObjects.forEach((cf) => {
                            const nodes: BaseNode[] = cf.children.map((obj) =>
                                BaseNode.fromObject(obj)
                            )
                            this.facetingService.setupNestedFacet(
                                cf.filter_id,
                                cf.filter_name,
                                nodes,
                                true
                            )
                        })
                    }
                )
            )
        } else {
            this.subscriptions.push(
                this.browsingService.tree.subscribe((disciplines: CHNode[]) => {
                    this.facetingService.setupNestedFacet(
                        CH_FACET_ID,
                        "Subject",
                        disciplines,
                        true
                    )
                })
            )
        }
    }

    private subscribeToFacetsInfo() {
        this.subscriptions.push(
            // Custom facets setup
            this.facetingService.nestedFacetsChanged.subscribe(
                (facets: Record<string, Facet<BaseNode>>) => {
                    this.nestedFacetsInfo = Object.values(facets)
                        .filter((f) => f.id !== CH_FACET_ID)
                        .map((f) => ({ id: f.id, name: f.name }))
                    this.chFacetInfo = facets[CH_FACET_ID]
                        ? { id: CH_FACET_ID, name: facets[CH_FACET_ID].name }
                        : {}
                }
            )
        )
    }

    public onClearClick() {
        this.facetingService.clearFilters(this.route)
    }

    public ngOnDestroy() {
        this.subscriptions.map((subscription) => subscription.unsubscribe())
    }
}
